import { render, staticRenderFns } from "./Supervisors.vue?vue&type=template&id=760def3c&"
import script from "./Supervisors.vue?vue&type=script&lang=js&"
export * from "./Supervisors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports